"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterTotalsRowModel = void 0;
const _ = __importStar(require("lodash"));
const numeral_1 = __importDefault(require("numeral"));
class FooterTotalsRowModel {
    isFooterTotalsRow;
    id;
    table;
    group;
    rowKey;
    validColumns;
    data;
    constructor(table, group) {
        this.isFooterTotalsRow = true;
        this.id = `table__footer_totals`;
        this.table = table;
        this.group = group;
        this.rowKey = group ? `${group.id}__footer_totals` : 'table_footer_totals';
        this.validColumns = this.getValidColumns(table);
        this.data = this.calculateTotals();
    }
    getValidColumns(table) {
        const result = [];
        for (let col of table.options.columns) {
            if ((col.type === 'number' || col.footerTotals) &&
                col.noFooterTotals !== true) {
                result.push(col.field || col.name);
            }
        }
        return result;
    }
    getValue(fieldName) {
        if (this.validColumns.indexOf(fieldName) > -1) {
            return this.data[fieldName];
        }
    }
    displayTotalsForColumn(column) {
        return this.validColumns.indexOf(column.field) > -1;
    }
    calculateTotals() {
        const cols = this.validColumns;
        const totals = {};
        const userCalculatedTotals = [];
        for (let col of this.table.options.columns) {
            if (_.isFunction(col.footerTotals)) {
                userCalculatedTotals.push(col);
                _.remove(cols, col.field || col.name);
            }
        }
        const numeralTotals = _.reduce(cols, (m, field) => {
            m[field] = (0, numeral_1.default)(0);
            return m;
        }, {});
        const rows = [];
        for (let row of this.table.iterRows(this.group ? this.group.id : '')) {
            rows.push(row);
            for (let fieldName of cols) {
                const value = row.getValue(fieldName);
                if (_.isNumber(value)) {
                    numeralTotals[fieldName].add(value);
                }
            }
        }
        _.each(numeralTotals, (v, k) => {
            totals[k] = v.value();
        });
        for (let col of userCalculatedTotals) {
            if (_.isFunction(col.footerTotals)) {
                totals[col.field || col.name] = col.footerTotals(rows) || 0;
            }
        }
        return totals;
    }
}
exports.FooterTotalsRowModel = FooterTotalsRowModel;
//# sourceMappingURL=footer-totals-row-model.js.map